

export class Utils {
    static filterSimilarObjectProps(obj: any, propStart: string, seperator: string = "-") {
        const props = Object.entries(obj).filter(entry => entry[0].startsWith(propStart))
        props.sort((a, b) => {
            const aIndex = Number.parseInt(a[0].split(seperator)[a[0].split(seperator).length])
            const bIndex = Number.parseInt(b[0].split(seperator)[b[0].split(seperator).length])
            return aIndex < bIndex ? -1 : aIndex === bIndex ? 0 : 1
        })
        return props.map(prop => prop[1])
    }

    static dynamicKeyAccess(obj: any, prop: string) {return obj[prop]}

    static dynamicKeyDelete = (obj: any, prop: string) => { delete obj[prop]}
}

